import * as Cookies from 'js-cookie'

// https://github.com/js-cookie/js-cookie/wiki/Frequently-Asked-Questions#expire-cookies-in-less-than-a-day
const inFiveMinutes = new Date(Date.now() + 5 * 60 * 1000)
const logoutCookieName = 'USER_LOGOUT'

export const LOGOUT_URL = '/apps/logout?redirect=/'

// create cookie so app handling logout can show a transient message
export const performLogout = redirectPath => {
  Cookies.set(logoutCookieName, 'y', { expires: inFiveMinutes })
  window.location.assign(redirectPath || LOGOUT_URL)
}

export const onLogoutHandlerFactory = path => e => {
  e.preventDefault()
  performLogout(path)
}

export const onLogoutHandler = onLogoutHandlerFactory(LOGOUT_URL)
